
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Link 
              to="/" 
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>戻る</span>
            </Link>
            <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              Enabling City Walk
            </h1>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        {/* Terms of Service Section */}
        <section className="mb-16">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-2 text-center">利用規約（EULA）</h2>
            <p className="text-lg text-gray-600 mb-8 text-center">Enabling City Walk（イネーブリングシティウォーク）</p>
            
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-6">
                この利用規約（以下「本規約」）は、イーネーブリングシティ協会（以下「当協会」）が運営するウェブアプリ「Enabling City Walk」（以下「本アプリ」）の利用条件を定めるものです。本アプリを利用するすべてのユーザー（以下「ユーザー」）は、本規約の内容に同意したものとみなされます。
              </p>

              <div className="space-y-8">
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">第1条（目的）</h3>
                  <p className="text-gray-700 leading-relaxed">
                    本アプリは、ユーザーがまちを歩きながら地域の魅力を発見し、感じたことを投稿・共有できることを目的としたアプリケーションです。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">第2条（投稿機能と責任）</h3>
                  <p className="text-gray-700 leading-relaxed">
                    ユーザーは、本アプリ上で文章・画像・写真等のコンテンツ（以下「投稿コンテンツ」）を投稿することができます。投稿内容についての責任は、すべて投稿を行ったユーザー自身が負うものとします。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">第3条（禁止事項）</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    ユーザーは、以下のいずれかに該当する内容を含む投稿をしてはなりません。
                  </p>
                  <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-4">
                    <li>個人情報（氏名、住所、電話番号、メールアドレス等）を含むもの</li>
                    <li>誹謗中傷、差別、ヘイトスピーチを含むもの</li>
                    <li>ポルノ、暴力、残虐な表現など不適切または不快な内容</li>
                    <li>著作権、肖像権、その他の権利を侵害するもの</li>
                    <li>広告、宣伝、営業行為に該当するもの</li>
                    <li>その他、公序良俗または法令に反する内容</li>
                  </ol>
                  <p className="text-gray-700 leading-relaxed mt-4">
                    当協会は、これらの禁止事項に該当する投稿を発見または報告を受けた場合、即時に非公開または削除し、必要に応じてユーザーの利用制限措置を講じるものとします。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">第4条（ゼロトレランス方針）</h3>
                  <p className="text-gray-700 leading-relaxed">
                    当協会は、不適切なコンテンツに対して一切の容認を行わないゼロトレランス方針を採用します。繰り返し違反を行ったユーザーに対しては、予告なくアカウント停止等の措置を行うことがあります。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">第5条（通報機能と運用体制）</h3>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    本アプリには投稿通報機能を設けており、ユーザーは不適切と判断した投稿を通報することができます。
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    当協会は、通報された投稿について、原則として24時間以内に確認および対応を行います。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">第6条（知的財産）</h3>
                  <p className="text-gray-700 leading-relaxed">
                    ユーザーが投稿した内容についての著作権は、原則として当該ユーザーに帰属します。ただし、当協会は地域のまちづくり、調査、研究等を目的として、投稿内容を利用・複製・編集・公開することができるものとします。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">第7条（免責事項）</h3>
                  <p className="text-gray-700 leading-relaxed">
                    本アプリの利用により生じたユーザー間のトラブル、または第三者との間の問題について、当協会は一切責任を負いません。また、システム障害や外部要因によりサービスの一時停止またはデータ消失等が発生した場合も、当協会は責任を負いません。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">第8条（利用停止）</h3>
                  <p className="text-gray-700 leading-relaxed">
                    ユーザーが本規約に違反した場合、当協会は事前の通知なく、投稿の削除、アカウント停止、サービスの利用制限等の措置を行うことができるものとします。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">第9条（規約の改定）</h3>
                  <p className="text-gray-700 leading-relaxed">
                    当協会は、必要に応じて本規約の内容を変更できるものとし、変更後の規約はアプリ内または当協会の公式ウェブサイト上で告知された時点で効力を発します。
                  </p>
                </div>

                <div className="text-xl font-bold text-gray-900 mb-4">第10条（準拠法・裁判管轄）</div>
                <p className="text-gray-700 leading-relaxed">
                  本規約は日本法に準拠し、万一の紛争が生じた場合は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
                </p>

                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">【お問い合わせ】</h3>
                  <div className="text-gray-700 leading-relaxed">
                    <p className="font-semibold">イーネーブリングシティ協会</p>
                    <p>住所：東京都千代田区内神田2丁目6番7号</p>
                    <p>メール：info@enablingcity.org</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Privacy Policy Section */}
        <section>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-2 text-center">プライバシーポリシー</h2>
            <p className="text-lg text-gray-600 mb-8 text-center">Enabling City Walk（イネーブリングシティウォーク）</p>
            
            <div className="prose prose-lg max-w-none">
              <div className="space-y-8">
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">1. 所有者について</h3>
                  <p className="text-gray-700 leading-relaxed">
                    本アプリ「Enabling City Walk」（以下「本アプリ」）は、イーネーブリングシティ協会（所在地：東京都千代田区内神田2丁目6番7号）が所有・運営しています。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">2. 収集する情報とその利用目的</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    本アプリでは、以下の情報を利用目的に応じて収集・使用します。
                  </p>
                  
                  <div className="space-y-4">
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <h4 className="font-bold text-gray-900 mb-2">・位置情報</h4>
                      <p className="text-gray-700 text-sm">
                        GPSによる現在地を取得し、現在地周辺の投稿表示、歩行ルートの記録、都市計画やまちづくりのための分析データとして活用します。
                      </p>
                    </div>
                    
                    <div className="bg-green-50 p-4 rounded-lg">
                      <h4 className="font-bold text-gray-900 mb-2">・カメラアクセス</h4>
                      <p className="text-gray-700 text-sm">
                        写真撮影機能のためにカメラを使用します。投稿された写真はイベント参加者に公開されます。
                      </p>
                    </div>
                    
                    <div className="bg-yellow-50 p-4 rounded-lg">
                      <h4 className="font-bold text-gray-900 mb-2">・デバイス情報</h4>
                      <p className="text-gray-700 text-sm">
                        使用端末やブラウザ、言語設定、タイムゾーンなどを取得し、利用状況の把握や不具合検出、UI最適化のために利用します。
                      </p>
                    </div>
                    
                    <div className="bg-purple-50 p-4 rounded-lg">
                      <h4 className="font-bold text-gray-900 mb-2">・ユーザー属性情報</h4>
                      <p className="text-gray-700 text-sm">
                        年齢層や性別などをユーザーが任意に設定する情報です。投稿やアンケート結果の集計・分析に使用しますが、個人を特定することはありません。
                      </p>
                    </div>
                    
                    <div className="bg-pink-50 p-4 rounded-lg">
                      <h4 className="font-bold text-gray-900 mb-2">・投稿内容</h4>
                      <p className="text-gray-700 text-sm">
                        文章や写真、画像などの投稿は、イベント中の共有や地域の魅力の可視化、まちづくりの参考資料として活用されます。
                      </p>
                    </div>
                  </div>
                  
                  <div className="bg-red-50 border border-red-200 p-4 rounded-lg mt-4">
                    <p className="text-red-800 text-sm font-medium">
                      ※メールアドレスや氏名など、個人を直接識別する情報は一切取得しません。投稿時には個人情報を含めないよう、利用者にご注意をお願いしています。
                    </p>
                  </div>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">3. ユーザー生成コンテンツ（UGC）と安全性の確保</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    本アプリには、ユーザーが投稿できる機能（文章、写真等）があります。安全にご利用いただくため、以下の対策を講じています。
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                    <li>アプリ利用開始時に利用規約（EULA）に同意していただき、不適切な投稿の禁止を明記しています。</li>
                    <li>各投稿には通報機能があり、報告された内容には原則24時間以内に対応します。</li>
                    <li>悪質な投稿を繰り返すユーザーに対しては、利用停止やアカウントの制限を行います。</li>
                    <li>他ユーザーの投稿を非表示にできるブロック機能を提供します。</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">4. 情報の共有と第三者提供について</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    本アプリで収集された情報は、以下の目的でのみ利用され、原則として第三者に提供することはありません。
                  </p>
                  <p className="text-gray-700 leading-relaxed mb-2">
                    ただし、以下に該当する場合はこの限りではありません。
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                    <li>法令に基づく要請がある場合</li>
                    <li>人命や財産の保護のために必要とされる緊急時</li>
                    <li>都市や地域の調査・まちづくり研究の目的で、行政機関や研究機関などと、個人が特定されない形式で情報を共有する場合</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">5. ユーザーの権利</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    利用者が自身の投稿の削除を希望される場合は、下記の問い合わせ先にご連絡いただければ、本人確認の上で速やかに対応いたします。
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    また、ユーザー属性情報や投稿内容はすべて匿名化された統計データとして扱い、個人を特定する目的では使用しません。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">6. プライバシーポリシーの改定について</h3>
                  <p className="text-gray-700 leading-relaxed">
                    本ポリシーは、必要に応じて予告なく改定される場合があります。変更があった場合は、アプリ内または協会のウェブサイト上で掲示し、掲載時点から適用されます。
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">7. お問い合わせ</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    本アプリに関するご質問やご相談は、以下の窓口までご連絡ください。
                  </p>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <div className="text-gray-700 leading-relaxed">
                      <p className="font-semibold">イーネーブリングシティ協会</p>
                      <p>住所：〒101-0047 東京都千代田区内神田2丁目6番7号</p>
                      <p>メールアドレス：info@enablingcity.org</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-200 py-8">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-gray-600 text-sm">
            © 2024 イーネーブリングシティ協会. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
